import { RedeemedCampaignTypeV2 } from '@/services/graphql/generated'
import { logger } from '@/services/logger/logger.client'
import { type ShopSession } from '@/services/shopSession/ShopSession.types'
import { useRedeemCampaign, useUnredeemCampaign } from '@/utils/useCampaign'
export const useCartDiscount = (shopSession: ShopSession) => {
  const [redeemCampaign, { loading: loadingRedeem, errorMessage }] = useRedeemCampaign({
    shopSessionId: shopSession.id,
  })

  const [unredeemCampaign, { loading: loadingUnredeem }] = useUnredeemCampaign({
    shopSessionId: shopSession.id,
  })

  const unredeem = () => {
    const campaignId = shopSession.cart.redeemedCampaignV2?.id

    if (!campaignId) {
      logger.warn('Tried to unredeem campaign without id')
      return
    }

    unredeemCampaign(campaignId)
  }

  const campaign = shopSession.cart.redeemedCampaignV2
  const campaignCode = campaign?.campaignCode
  const codeExplanation = campaign?.type === RedeemedCampaignTypeV2.Referral ? campaign.displayValue : null
  const isLoading = loadingRedeem || loadingUnredeem

  return {
    campaignCode,
    codeExplanation,
    isLoading,
    errorMessage,
    redeemCampaign,
    unredeemCampaign: unredeem,
  }
}
